import 'whatwg-fetch';
require('es6-promise').polyfill();

import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import App from './App';
import store from './store';

import loadParams from './actions/load-params';
import runAnalysis from './actions/query-api/run-analysis';
import getFeatures from './actions/query-api/features';
import getBenchmarks from './actions/query-api/benchmarks';
import getCompliance from './actions/query-api/compliance';
import allowClientLogo from './actions/query-api/allow-client-logo';
import { fetchExamplePortfolio } from './actions/query-api/example-portfolio';
import fetchModelPortfolios from './actions/query-api/model-portfolios';
import loadPersonalStrategies from './actions/query-api/personal-strategies.js';

import './App/style.css';

// the id of the div for render
let appId = 'root';

// override appId from window param
if(window.dpd && window.dpd.appId) {
  appId = window.dpd.appId;
}

// polyfill Object.values
Object.values = Object.values || function (obj) {
  return Object.keys(obj).map(e => obj[e])
}

// polyfill Object.entries
if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
    while (i--)
      resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };
}

if (window.portfolioMapper) {
  store.dispatch({
    type: 'RECORD_PARAMS',
    params: {
      token: process.env.REACT_APP_AUTH_TOKEN,
      version: process.env.REACT_APP_VERSION,
      ...window.portfolioMapper,
    },
  });

}

store.dispatch(loadParams(window.location.search));
store.dispatch(getFeatures());
store.dispatch(getBenchmarks());
store.dispatch(allowClientLogo());
store.dispatch(fetchExamplePortfolio('example'));
store.dispatch(fetchExamplePortfolio('example_template'));
store.dispatch(getCompliance());
store.dispatch(fetchModelPortfolios());
store.dispatch(loadPersonalStrategies());

if (process.env.REACT_APP_OFFLINE_MODE === 'report') {
  store.dispatch(runAnalysis());
}

render(
  <BrowserRouter><Provider store={store}><App /></Provider></BrowserRouter>,
  document.getElementById(appId)
);


// WEBPACK FOOTER //
// ./src/index.js